import Chart from "../../../../src/articles/annual-report/2021/02-review/10-financial-year-annual-story/chart-1.tsx";
import * as React from 'react';
export default {
  Chart,
  React
};